<template>
  <v-card class="custom-naj-card-hover">
    <v-row class="ma-0 max-width-80">
      <v-col
        v-for="(header,index) in headers"
        :key="index"
        class="pt-0 pb-0"
        cols="2"
      >
        <div>
          <label class="d-block"> {{ header.name }}</label>
          <p class="mb-0 font-weight-bold">
            {{ header.formatter ? header.formatter(item[header.value]) : item[header.value] }}
          </p>
        </div>
      </v-col>
      <span
        class="status"
        :style="{ 'background-color': status.color }"
      >{{ status.name }}</span>
    </v-row>
  </v-card>
</template>

<script>

export default {
  name: 'CaseCard',
  components: {},
  props: {
    headers: {
      type: Array,
      default: () => ([]),
    },
    status: {
      type: Object,
      default: () => ({}),
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.max-width-80 {
  max-width: 80%;
}

.custom-naj-card-hover.v-card {
  padding: 12px;
  box-sizing: content-box;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  transition: all 0.3s;
  position: relative;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,
    rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
  &:hover {
    border: 2px solid #b39a6d;
    cursor: pointer;
  }

  p,
  label {
    color: #34675a;
    font-weight: 400;
    font-size: 0.9rem;
    text-wrap: nowrap;
  }
  h4 {
    color: #343a40;
    font-size: 18px;
    margin: 0 0 24px 0;
    .v-icon {
      font-size: 18px;
      color: #343a40;
    }
  }

  .status {
    border-radius: 0.25rem !important;
    color: white;
    font-size: 0.75rem;
    font-weight: bold;
    padding: 2px 4px;
    position: absolute;
    left: 12px;
  }
}
</style>
